import { render, staticRenderFns } from "./StockPositionKindDetails.vue?vue&type=template&id=1f293774&"
import script from "./StockPositionKindDetails.vue?vue&type=script&lang=js&"
export * from "./StockPositionKindDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports